<template>
  <div class="stickers-tools-border">
    <h3 class="stickers-tools-border__title">Select Border Thickness</h3>
    <StickersToolsItems
      :value="selectedBorderThickness"
      :items="borderThicknesses"
      @change="handleBorderThicknessChange"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import StickersToolsItems from "components/jiffy/vue-product-details-dtf/Stickers/StickersTools/StickersToolsItems.vue";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";
import { useDtfStore } from "../../store";
import { useStickersStore } from "../../stickers-module";

const borderThicknesses = [
  {
    label: "Small",
    value: "small",
    icon: "https://jiffy.imgix.net/gen/sticker-shapes/border-small.png"
  },
  {
    label: "Medium",
    value: "medium",
    icon: "https://jiffy.imgix.net/gen/sticker-shapes/border-medium.png"
  },
  {
    label: "Large",
    value: "large",
    icon: "https://jiffy.imgix.net/gen/sticker-shapes/border-large.png"
  }
];

const props = defineProps({
  artwork: [Object, null]
});

const store = useDtfStore();
const stickersStore = useStickersStore();
const selectedBorderThickness = computed(() => props.artwork.paddingSize);

const handleBorderThicknessChange = borderThickness => {
  store.updateArtworkValuesById({ id: props.artwork.id, paddingSize: borderThickness });

  if (!props.artwork.isFile && !props.artwork.isSimulated) {
    const payload = {
      page: "PDP",
      business_line: "Stickers",
      artwork_id: props.artwork.id,
      border_size: borderThickness,
      is_bg_removed: props.artwork.removeBackground
    };

    submitDtfEvent("sticker_select_border_size", payload);

    stickersStore.generateStickerImage({
      artwork: props.artwork,
      paddingSize: borderThickness
    });
  }
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/jiffy/settings";

.stickers-tools-border {
  &__title {
    margin: 16px 0;
    color: $text-black;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.3;
  }
}
</style>
